// @packages
import { makeStyles } from '@rneui/themed';

export default makeStyles((theme) => ({
  container: {
    alignItems: 'center'
  },
  noSitesText: {
    color: theme.colors.grey2
  },
  titleText: {
    color: theme.colors.primary,
    fontSize: 25,
    fontWeight: 'bold',
    marginBottom: 30
  }
}));
